import getConfig from 'next/config';

export { getServerCookie } from './CookieUtils';

export const {
  publicRuntimeConfig: {
    CDN_STATIC_ASSETS,
    ENVIRONMENT_NAME,
    MIGRATED_PUBLISH_SECTIONS,
    BASE_URL,
    API_CLIENT_TIMEOUT,
    DFP_PHOTOBROWSER_REFRESH_THRESHOLD,
    DISPLAY_CERTIFIED_TRUSTED_DEALER_CARS_FILTER,
    HUBVISOR_SCRIPT_ENABLED,
    FEATURE_ADP_STICKY_CTA_ALWAYS_VISIBLE,
    ENABLE_SYNC_CONVERT_SCRIPT,
    ENABLE_NEW_STRIPE_CHECKOUT,
    STRIPE_EXPERIMENT_NAME,
    STRIPE_EXPERIMENT_VARIATION_KEY,
    CONVERT_ACCOUNT_ID,
    CONVERT_FULLSTACK_PROJECT_ID,
    FEATURE_TDP_UPDATES,
    FEATURE_FREE_HISTORY_CHECK,
    PRISMIC_REPOSITORY_NAME,
    FEATURE_PRICING_INDICATOR,
    ENABLE_LOGGED_OUT_DEALER_ENQUIRY_MODAL,
    PRICING_INDICATOR_EXPERIMENT_KEY,
    PRICING_INDICATOR_EXPERIMENT_STATUS,
    PRICING_INDICATOR_EXPERIMENT_CONTROL_WEIGHT,
    PRICING_INDICATOR_EXPERIMENT_VARIANT_WEIGHT,
    FEATURE_CAR_FINANCE_UPDATES,
  },
} = getConfig();
